import { render } from "./AddNewTask.vue?vue&type=template&id=ef06045e"
import script from "./AddNewTask.vue?vue&type=script&lang=js"
export * from "./AddNewTask.vue?vue&type=script&lang=js"

import "./AddNewTask.vue?vue&type=style&index=0&id=ef06045e&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__